const model = {
    submitting: false,
    errors: null,
    offer: null,
    success: false,
    productDetails: [],
};

export default model;